<template>
    <v-layout wrap>
        <v-navigation-drawer absolute permanent right style="width: 600px;">
            <!--  상단 이미지 및 선택 타이틀 이름-->
            <v-list class="pa-1">
                <v-list-item>
                    <v-tabs v-if="copyValue._instanceInfo">
                        <v-tab v-if="copyValue._instanceInfo">
                            <v-list-item-title>Instance Info</v-list-item-title>
                        </v-tab>
                    </v-tabs>
                    <v-tabs v-model="tab">
                        <v-tab v-for="tab in tabs" :key="tab" :id="tab.toLowerCase() + _uid">
                            <v-list-item-title>{{ tab }}</v-list-item-title>
                        </v-tab>
                    </v-tabs>
                    
                    <v-btn icon @click.native="closePanel()">
                        <v-icon color="grey lighten-1">mdi-close</v-icon>
                    </v-btn>
                </v-list-item>
            </v-list>

            <v-simple-table  v-if="copyValue._instanceInfo">
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">Key</th>
                            <th class="text-left">Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, index) in copyValue._instanceInfo" :key="index">
                            <td>{{ index }}</td>
                            <td>{{ copyValue._instanceInfo[index] }}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>

            <v-list class="pt-0" dense flat>
                <v-divider></v-divider>
                <div v-if="tab == 0" style="margin-top: 10px">
                    <v-card flat>
                        <v-card-text>
                            <v-text-field
                                    v-if="tracingTag !== null"
                                    v-model="tracingTag"
                                    label="액티비티 ID*"
                                    counter="50"
                                    autofocus
                            ></v-text-field>
                            <v-text-field
                                    v-if="copyValue._type == 'org.uengine.kernel.bpmn.CatchingErrorEvent' || 
                                        copyValue._type == 'org.uengine.kernel.bpmn.Event'"
                                    v-model="namePanel"
                                    label="액티비티 명"
                            ></v-text-field>
                            <v-text-field
                                    v-else-if="copyValue._type == 'org.uengine.kernel.bpmn.TimerIntermediateEvent'"
                                    v-model="namePanel"
                                    label="Name"
                            ></v-text-field>
                            <v-text-field
                                    v-else
                                    v-model="namePanel"
                                    label="Event Name"
                            ></v-text-field>

                            <!-- v-if="copyValue._type == 'org.uengine.kernel.bpmn.MessageIntermediateCatchEvent'" start -->
                            <div v-if ="copyValue._type == 'org.uengine.kernel.bpmn.MessageIntermediateCatchEvent'">
                                <v-text-field
                                        v-model="copyValue.servicePath"
                                        label="Service Path"
                                ></v-text-field>
                                <v-text-field
                                        v-model="copyValue.correlationKey"
                                        label="Correlation Key"
                                ></v-text-field>
                                <v-text-field
                                        v-model="copyValue.dataOutput.name"
                                        label="Data for Output"
                                ></v-text-field>
                                <label>Data Mapping</label>
                                <bpmn-parameter-contexts
                                        :parameter-contexts="copyValue.dataOutputMapping"
                                        :definition="definition"
                                ></bpmn-parameter-contexts>
                            </div>
                            <!-- v-if="copyValue._type == 'org.uengine.kernel.bpmn.MessageIntermediateCatchEvent'" end -->

                            <!-- v-if="copyValue._type == 'org.uengine.kernel.bpmn.ConditionalCatchEvent'" start -->
                            <div v-if="copyValue._type == 'org.uengine.kernel.bpmn.ConditionalCatchEvent'">
                                <label>Condition</label>
                                <v-checkbox 
                                        v-model="complexCondition"
                                        label="Complex Rule"
                                ></v-checkbox>
                                <div v-if="complexCondition">
                                    <org-uengine-kernel-Or 
                                            v-model="copyValue.condition" 
                                            :definition="definition"
                                    ></org-uengine-kernel-Or>
                                </div>
                                <org-uengine-kernel-Evaluate 
                                        v-else 
                                        v-model="copyValue.condition" 
                                        :definition="definition"
                                ></org-uengine-kernel-Evaluate>
                                <v-text-field
                                        v-model="copyValue.pollingIntervalInSecond"
                                        label="Polling Interval (in seconds)"
                                        type="number"
                                ></v-text-field>
                            </div>
                            <!-- v-if="copyValue._type == 'org.uengine.kernel.bpmn.ConditionalCatchEvent'" end -->

                            <!-- v-if="copyValue._type == 'org.uengine.kernel.bpmn.MessageIntermediateThrowEvent'" start -->
                            <div v-if="copyValue._type == 'org.uengine.kernel.bpmn.MessageIntermediateThrowEvent'">
                                <v-text-field
                                        v-model="copyValue.role.name"
                                        label="Target Service Pool"
                                        readonly
                                ></v-text-field>
                                <v-text-field
                                        v-model="copyValue.uriTemplate"
                                        label="호출 URI 패턴"
                                ></v-text-field>
                                <v-checkbox
                                        v-if="copyValue.uriTemplate && copyValue.uriTemplate.indexOf('https://') == 0"
                                        v-model="copyValue.noValidationForSSL"
                                        label="Don't validate the certificate"
                                ></v-checkbox>
                                <v-select
                                        v-if="links"
                                        :items="links"
                                        item-text="key"
                                        item-value="href"
                                        @change="giveJSONHint"
                                        label="호출 서비스 선택"
                                ></v-select>
                                <v-select
                                        v-model="copyValue.method"
                                        :items="methodList"
                                        label="호출 메서드"
                                ></v-select>
                                <div v-if="'GET,DELETE'.indexOf(copyValue.method) == -1">
                                    <label>Input</label>
                                    <v-switch
                                            v-model="copyValue.useJSONTemplate"
                                            label="Use JSON Template"
                                    ></v-switch>
                                    <v-textarea
                                            v-if="useJSONTemplate"
                                            v-model="copyValue.uriTemplate"
                                            label="입력 데이터 (JSON template)"
                                    ></v-textarea>
                                    <bpmn-variable-selector 
                                            v-else
                                            v-model="inputVariable" 
                                            :definition="definition" 
                                            style="width: 100%; height: 80px;" 
                                    ></bpmn-variable-selector>
                                </div>
                                <label>Headers</label>
                                <div v-for="(header, index) in copyValue.headers" :key="index">
                                    <v-text-field
                                            v-model="copyValue.headers[index].name"
                                            label="Name"
                                    ></v-text-field>
                                    <v-text-field
                                            v-model="copyValue.headers[index].value"
                                            label="Value"
                                    ></v-text-field>
                                    <v-btn @click="deleteHeader(index)">delete</v-btn>
                                </div>
                                <br />
                                <v-btn 
                                        @click="addHeader" 
                                        color="primary" class="my-5"
                                >Add header</v-btn>
                                <br />
                                <label>Output</label>
                                <bpmn-parameter-contexts
                                        :parameter-contexts="copyValue.outputMapping"
                                        :definition="definition"
                                ></bpmn-parameter-contexts>
                                <v-checkbox
                                        v-model.number="copyValue.skipIfNotFound"
                                        label="리소스 없을 경우 (404) 오류 처리 하지 않음"
                                ></v-checkbox>
                                <v-checkbox
                                        v-model.number="copyValue.queuingEnabled"
                                        label="Queuing Enabled"
                                ></v-checkbox>
                            </div>
                            <!-- v-if="copyValue._type == 'org.uengine.kernel.bpmn.MessageIntermediateThrowEvent'" end -->

                            <!-- v-if="copyValue._type == 'org.uengine.kernel.bpmn.TimerIntermediateEvent'" start -->
                            <div v-if ="copyValue._type == 'org.uengine.kernel.bpmn.TimerIntermediateEvent'">
                                <v-select 
                                        v-model="copyValue.scheduleType"
                                        :items="scheduleTypeList"
                                        item-text="text"
                                        item-value="value"
                                        item-disabled="disabled"
                                ></v-select>
                                <v-text-field
                                        v-if="copyValue.scheduleType == 'cron'"
                                        v-model="copyValue.expression"
                                        label="Quartz Cron Expression"
                                >
                                    <a href="http://www.cronmaker.com/" target="_blank">Cron Maker</a>
                                </v-text-field>
                                <v-text-field
                                        v-if="copyValue.scheduleType == 'sec'"
                                        v-model="copyValue.expression"
                                        label="Interval in Second"
                                        type="number"
                                ></v-text-field>
                            </div>
                            <!-- v-if="copyValue._type == 'org.uengine.kernel.bpmn.TimerIntermediateEvent'" end -->

                            <v-text-field
                                    v-if="copyValue._type != 'org.uengine.kernel.bpmn.CatchingErrorEvent' && 
                                        copyValue._type != 'org.uengine.kernel.bpmn.ConditionalCatchEvent'"
                                    v-model="copyValue.retryDelay"
                                    label="retryDelay"
                                    type="number"
                            ></v-text-field>
                            <v-text-field
                                    v-if="copyValue._type == 'org.uengine.kernel.bpmn.CatchingErrorEvent' ||
                                        copyValue._type == 'org.uengine.kernel.bpmn.TimerIntermediateEvent'"
                                    v-model="copyValue.attachedToRef"
                                    label="부착 액티비티 ID"
                            ></v-text-field>
                            <v-text-field
                                    v-if="copyValue._type == 'org.uengine.kernel.bpmn.EscalationIntermediateCatchEvent' || 
                                        copyValue._type == 'org.uengine.kernel.bpmn.SignalIntermediateCatchEvent'"
                                    v-model="copyValue.attachedToRef"
                                    label="Attach Activity ID"
                            ></v-text-field>
                        </v-card-text>
                    </v-card>
                </div>
                <div v-if="tab == 1">
                    <v-card flat>
                        <v-card-text>
                            <v-row>
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                            label="x"
                                            v-model="x"
                                            type="number"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                            label="y"
                                            v-model="y"
                                            type="number"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                            label="width"
                                            v-model="width"
                                            type="number"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                            label="height"
                                            v-model="height"
                                            type="number"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-text-field
                                    v-for="(item, idx) in style" :key="idx"
                                    v-model="style[idx].value"
                                    :label="item.key"
                            ></v-text-field>
                        </v-card-text>
                    </v-card>
                </div>
            </v-list>

        </v-navigation-drawer>
    </v-layout>
</template>

<script>
    import BpmnPropertyPanel from '../../BpmnPropertyPanel'

    export default {
        mixins: [BpmnPropertyPanel],
        name: 'bpmn-intermediate-event-panel',
        props: {
            isComplexCondition: Boolean,
            linkList: Array,
            // useJSONTemplate,
        },
        data() {
            return {
                tabs: [ 'Properties', 'Visual' ],
                tab: null,
                complexCondition: this.isComplexCondition,  // org.uengine.kernel.bpmn.ConditionalCatchEvent
                links: this.linkList,    // org.uengine.kernel.bpmn.MessageIntermediateThrowEvent
                methodList: [ 'GET', 'POST', 'DELETE', 'PUT', 'PATCH' ],    // org.uengine.kernel.bpmn.MessageIntermediateThrowEvent
                scheduleTypeList: [
                    { text: 'Cron Expression', value: 'cron' },
                    { text: 'Interval in second', value: 'sec' },
                    { text: 'Available in Enterprise Edition', value: '', disabled: true },
                    { text: 'Interval in minute', value: 'min' },
                    { text: 'Interval in hour', value: 'how' },
                    { text: 'Interval in mili-second', value: 'milisec' },
                ],
            }
        },
        created: function () {
        },
        mounted: function () {
            // console.log(this.definition)
        },
        computed: {},
        watch: {},
        methods: {
            // org.uengine.kernel.bpmn.MessageIntermediateThrowEvent
            giveJSONHint() {
                this.$emit('giveJSONHint');
            },
            deleteHeader(idx) {
                this.$emit('deleteHeader', idx);
            },
            addHeader() {
                this.$emit('addHeader');
            },
        }
    }
</script>


<style lang="scss" rel="stylesheet/scss">

</style>

